<template>
    <b-container fluid>
        <b-row class="">
			<b-col cols="12" lg="12">
                <div class="d-flex justify-content-between align-items-end border-bottom pb-3">
                    <div class="">
                        <h3 class="">🎯평가관리</h3>
                        <p class="fw-400 text-secondary mb-0">프로젝트에 등록된 업체와 평가 진행 현황을 관리합니다. (미신청 업체 포함)</p>
                    </div>
                </div>
			</b-col>
		</b-row>
        <template v-if="is_initial_loading">
            <b-row class="admin-body-full-height mt-3">
                <b-col cols="12">
                    <div class="d-flex align-items-center justify-content-center bgray-200 h-100">
                        <b-spinner class="align-middle mr-3"></b-spinner>
                        <h3 class="mb-0">Loading...</h3>
                    </div>
                </b-col>
			</b-row>
        </template>
        <template v-else>
            <b-row class="my-4">
                <b-col cols="12">
                    <b-card>
                        <template #header>
                            <div class="d-flex align-items-center justify-content-between">
                                <h5 class="mb-0">🔎평가 검색</h5>

                                <div>
                                    <b-btn variant="primary"
                                        class="mr-2"
                                        :disabled="is_gloabl_loading"
                                        @click="searchAssessments"
                                        >
                                        조회하기
                                    </b-btn>
                                    <b-btn variant="outline-secondary"
                                        :disabled="is_gloabl_loading"
                                        @click="searchAssessments(true)"
                                        >
                                        초기화
                                    </b-btn>
                                </div>
                            </div>
                        </template>
                        <div class="pl-3">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group
                                        id="fieldset-period"
                                        label="PERIOD"
                                        label-for="input-period"
                                        >
                                        <!-- <b-form-input id="input-project-code" v-model="filters.project_code" trim></b-form-input> -->
                                        <b-form-checkbox-group
                                            id="input-period"
                                            v-model="filters.periods"
                                            :options="periods"
                                            value-field="value"
                                            text-field="text"
                                            disabled-field="notEnabled"
                                            :disabled="is_gloabl_loading"
                                            @change="searchAssessments"
                                            >
                                        </b-form-checkbox-group>
                                        <b-btn size="sm" variant="outline-secondary" class="mt-1"
                                            :disabled="is_gloabl_loading"
                                            title="전 기간은 조회가 오래 걸릴 수 있습니다"
                                            @click="selectAllPeriods">
                                            전체 기간
                                        </b-btn>
                                        <b-alert v-if="periods_error" variant="danger" show class="mt-2 mb-0 py-1 px-2">
                                            기간 목록을 불러오지 못했습니다.
                                            <b-link class="ml-1" @click="retryPeriods">다시 시도</b-link>
                                        </b-alert>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-project-code"
                                        label="프로젝트 코드"
                                        label-for="input-project-code"
                                        >
                                        <auto-complete-select
                                            id="input-project-code"
                                            v-model="selectedProjectId"
                                            :options="projectCodeOptions"
                                            option-value-key="id"
                                            placeholder="프로젝트 코드 선택 또는 검색"
                                            :disabled="is_gloabl_loading"
                                            start-expanded
                                            clearable
                                            @input="onProjectCodeSelected"
                                            />
                                        <b-alert v-if="projects_error" variant="danger" show class="mt-2 mb-0 py-1 px-2">
                                            프로젝트 목록을 불러오지 못했습니다.
                                            <b-link class="ml-1" @click="retryProjectCodes">다시 시도</b-link>
                                        </b-alert>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-assessment-type"
                                        label="평가유형"
                                        label-for="input-assessment-type"
                                        >
                                        <b-form-select id="input-assessment-type"
                                            v-model="filters.service_type"
                                            :disabled="is_gloabl_loading"
                                            @change="searchAssessments"
                                            >
                                            <option value="" selected>평가유형 선택</option>
                                            <option value="일반"> 일반</option>
                                            <option value="심화">심화</option>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-status"
                                        label="진행상태"
                                        label-for="input-status"
                                        >
                                        <b-form-select id="input-status" v-model="filters.status_code" :options="statusOptions" :disabled="is_gloabl_loading" @change="searchAssessments">
                                            <template #first>
                                                <option :value="null">진행상태 선택</option>
                                            </template>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-company-name"
                                        label="기업명"
                                        label-for="input-company-name"
                                        >
                                        <b-form-input id="input-company-name"
                                            v-model="filters.company_name"
                                            :disabled="is_gloabl_loading"
                                            trim
                                            @keypress.enter="searchAssessments"
                                            />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-request-username"
                                        label="신청인"
                                        label-for="input-request-username"
                                        >
                                        <b-form-input id="input-request-username"
                                            v-model="filters.user_name"
                                            :disabled="is_gloabl_loading"
                                            trim
                                            @keypress.enter="searchAssessments"
                                            />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6" xl="4">
                                    <b-form-group
                                        id="fieldset-request-usermail"
                                        label="신청 이메일"
                                        label-for="input-request-usermail"
                                        >
                                        <b-form-input
                                            id="input-request-usermail"
                                            v-model="filters.e_mail"
                                            :disabled="is_gloabl_loading"
                                            trim
                                            @keypress.enter="searchAssessments"
                                            />
                                    </b-form-group>
                                </b-col>
                                
                            </b-row>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row class="assessment-panel">
                <b-col cols="12" class="h-md-100 mb-3">
                    <b-card class="shadow-sm" no-body>
                        <template #header>
                            <div class="d-flex align-items-center justify-content-between flex-wrap">
                                <h5 class="mb-0">🎯평가 관리 데이터</h5>
                                <div class="d-flex align-items-center flex-wrap">
                                    <b-pagination
                                        v-model="assessment_currentPage"
                                        :total-rows="assessments.length"
                                        :per-page="assessment_perPage"
                                        :disabled="is_loading_assessments"
                                        class="mr-3 mb-0"
                                        size="sm"
                                        aria-controls="assessment-table"
                                        @change="onPageChange"
                                        />
                                    현재 데이터 개수: {{ data_num }} 개
                                </div>
                            </div>
                        </template>
                        <div class="">
                            <!-- 페이지 이동 버튼이 화면 안에 보이도록 표 높이를 뷰포트보다 낮게 잡는다 -->
                            <b-table id="assessment-table"
                                ref="assessmentTable"
                                :items="assessments"
                                :fields="assessment_fields"
                                :per-page="assessment_perPage"
                                :current-page="assessment_currentPage"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                class="mb-0"
                                show-empty
                                sticky-header="calc(100vh - 240px)"
                                thead-class="sticky-header-sort-fix"
                                sort-icon-left
                                :busy="is_loading_assessments"
                                @sort-changed="onSortChanged"
                                >

                                <template #empty>
                                    <page-empty-component compact
                                        :text="emptyText"
                                        :error="list_error"
                                        @retry="fetchAssessments"
                                        />
                                </template>

                                <template #table-busy>
                                    <div class="d-flex align-items-center justify-content-center my-3">
                                        <b-spinner class="align-middle mr-2" style="width: 1.3rem; height: 1.3rem"></b-spinner>
                                        <strong>조회중...</strong>
                                    </div>
                                </template>

                                <template #cell(index)="data">
                                    {{ data.value + 1 }}
                                </template>

                                <template #cell(service_type)="data">
                                    <div :class="['f-95', service_type_variant[data.value], 'fw-500 rounded px-1 py-1']">
                                        {{  data.value }}
                                    </div>
                                </template>

                                <template #cell(company_name)="data">
                                    <div class="mb-2">
                                        {{ data.item.company_name }}
                                        <b-badge variant="light">
                                            {{ data.item.company_id }}
                                        </b-badge>
                                    </div>

                                    <div class="border border-color-gray-300 bgray-100 rounded">
                                        <div class="border-bottom border-color-gray-300 px-2 py-1">
                                            {{ data.item.user_name }}
                                            <b-badge variant=" bgray-300">
                                                {{ data.item.user_id }}
                                            </b-badge>
                                        </div>
                                        <div class="px-2 py-1">
                                            <p class="mb-0">
                                                {{ data.item.e_mail }}
                                            </p>
                                        </div>
                                    </div>
                                </template>

                                <template #cell(campaign_id)="data">
                                    <div v-if="data.item.campaign_id">
                                        {{ data.item.campaign_name }}
                                        <b-badge variant="light">
                                            {{ data.item.campaign_id }}
                                        </b-badge>
                                    </div>
                                    <div v-else>
                                        -
                                    </div>
                                </template>

                                <template #cell(requested_ts)="data">
                                    <div class="date-text">
                                        {{ data.item.requested_ts ? data.item.requested_ts : '-' }}
                                    </div>
                                </template>

                                <template #cell(duedate_ts)="data">
                                    <div class="date-text" :class="getDuedateVarient(data.item)">
                                        <b> {{ data.item.duedate_ts }} </b>
                                    </div>
                                </template>

                                <template #cell(in_assessment_ts)="data">
                                    <div class="date-text">
                                        {{ data.item.in_assessment_ts ? data.item.in_assessment_ts : '-' }}
                                    </div>
                                </template>

                                <template #cell(completed_ts)="data">
                                    <div class="date-text">
                                        {{ data.item.completed_ts ? data.item.completed_ts : '-' }}
                                    </div>
                                </template>

                                <template #cell(status_code)="data">
                                    <div v-if="data.item.status_code">
                                        <h6>
                                            <b-badge pill :variant="getStatusVarient(data.item)">
                                                {{ getKoreanStatus(data.item) }}
                                            </b-badge>
                                        </h6>
                                    </div>
                                </template>

                                <template #cell(status_change)="data">
                                    <b-button v-if="data.item.status_code == 'in_progress'"
                                        size="sm"
                                        variant="outline-secondary"
                                        :disabled="is_admin !== 4 || is_loading_submit_by_qesg"
                                        @click="submitAnswerByQesg(data.item)"
                                        >
                                        임의제출
                                    </b-button>
                                    <b-button v-if="data.item.status_code == 'in_assessment'"
                                        size="sm"
                                        variant="outline-primary"
                                        :disabled="is_admin !== 4 || is_loading_change_answer_mode"
                                        @click="backToInProgress(data.item)"
                                        >
                                        답변수정
                                    </b-button>
                                </template>

                                <template #cell(member)="data">
                                    <b-button size="sm" variant="dark-border"
                                        :disabled="is_loading_member_modal"
                                        @click.stop="openMemberModal(data.item)"
                                        >
                                        참여자
                                    </b-button>
                                </template>

                                <template #cell(admin)="data">
                                    <b-button size="sm" @click.stop="openCommentModal(data.item)">
                                        <fa icon="comment-dots"></fa>
                                    </b-button>
                                </template>
                            </b-table>
                        </div>
                    </b-card>
                </b-col>
            </b-row>

            <b-modal id='comment-modal'
                title="기업 커뮤니케이션 로그"
                size="lg"
                hide-footer
                >
                <comm-log :comment_company="comment_info"></comm-log>
            </b-modal>

            <assessment-member-modal v-if="member_modal_company"
                ref="assessment-member-modal"
                :selected_company="member_modal_company"
                />
        </template>
    </b-container>
</template>
  
<script>
import { getErrorMessage } from '@core/utils/api/errorMessage'
import CommLog from '@shared_components/admin/components/managing/CommLog.vue'
import AutoCompleteSelect from '@core/components/common/AutoCompleteSelect.vue'
import PageEmptyComponent from '@shared_components/admin/components/common/PageEmptyComponent.vue'
import { STATUS_LABELS } from '@shared/mixin/assessment.common.mixin'
import { getProjectCodeOptions } from './Management/common-data'
import AssessmentMemberModal from './Management/Company/_SubComponent/AssessmentMemberModal.vue'

// URL query 키. 기간(periods)·페이지·정렬은 따로 다룬다
const FILTER_KEYS = ['project_code', 'service_type', 'status_code', 'company_name', 'user_name', 'e_mail']
const VIEW_KEYS = ['current_page', 'sort_by', 'sort_desc']
const STATUS_FILTER_CODES = ['not_requested', 'requested', 'in_progress', 'in_assessment', 're_progress', 'completed', 'canceled']

// 같은 조건인지 비교한다 — 단일값/배열, 값 순서 차이는 무시
const queryKey = (query, keys) => JSON.stringify(keys.map(k => [].concat(query[k] == null ? [] : query[k]).map(String).sort()))

export default {
    name: 'admin-assessment',
    components: {
        CommLog,
        AutoCompleteSelect,
        AssessmentMemberModal,
        PageEmptyComponent
    },
    data() {
        return {
            is_initial_loading: false,
            is_loading_assessments: false,
            is_loading_change_answer_mode: false,
            is_loading_submit_by_qesg: false,

            assessment_perPage: 50,
            assessment_currentPage: 1,
            // URL·사용자가 원한 페이지. b-pagination 이 이전 건수 기준으로 깎아도 결과가 오면 이 값으로 맞춘다
            requested_page: 1,
            sortBy: '',
            sortDesc: false,
            // 기간·프로젝트 목록을 받은 뒤부터 URL 변화를 화면에 반영한다
            query_ready: false,

            assessments: [],
            periods: [],
            projects: [],
            selectedProjectId: null,
            data_num: 0,

            periods_error: false,
            projects_error: false,
            list_error: '',
            // 늦게 도착한 이전 조회 응답을 버리기 위한 순번
            search_token: 0,

            // 화면에서 고치는 중인 조건. 조회할 때 applied_filters 로 옮겨 URL·요청에 쓴다
            filters: {
                periods: [],
                project_code: null,
                service_type: null,
                status_code: null,
                company_name: null,
                user_name: null,
                e_mail: null
            },
            applied_filters: { periods: [] },

            assessment_fields: [
                {
                    key: 'index',
                    label: '번호',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%;',
                    tdClass: 'text-center'
                },
                {
                    key: 'period',
                    label: 'PERIOD',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%; '
                },
                {
                    key: 'project_code',
                    label: '프로젝트코드',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%; '
                },
                {
                    key: 'service_type',
                    label: '평가유형',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:5%; ',
                    tdClass: 'text-center',
                },
                {
                    key: 'company_name',
                    label: '기업 및 신청인',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'min-width: 220px;'
                },
                {
                    key: 'campaign_id',
                    label: '캠페인',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:25%; '
                },
                {
                    key: 'requested_ts',
                    label: '신청일  ',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; '
                },
                {
                    key: 'duedate_ts',
                    label: '제출기한',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; font-weight: bold; '
                },
                {
                    key: 'in_assessment_ts',
                    label: '평가시작',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; '
                },
                {
                    key: 'completed_ts',
                    label: '완료일',
                    sortable: true,
                    thClass: 'mb-0',
                    thStyle: 'width:8%; '
                },
                {
                    key: 'status_code',
                    label: '진행상태',
                    sortable: true,
                    thClass: 'mb-0',
                    tdClass: 'text-center',
                    thStyle: 'width:5%; min-width: 90px;'
                },
                {
                    key: 'status_change',
                    label: '상태변경',
                    sortable: true,
                    thClass: 'mb-0',
                    tdClass: 'text-center',
                    thStyle: 'width:5%;'
                },
                {
                    key: 'member',
                    label: '참여자',
                    sortable: false,
                    thClass: 'mb-0 text-center',
                    tdClass: 'text-center',
                    thStyle: 'width:4%;'
                },
                {
                    key: 'admin',
                    label: '히스토리',
                    sortable: false,
                    thClass: 'mb-0 text-center',
                    tdClass: 'text-center',
                    thStyle: 'width:3%;'
                },
            ],

            comment_info: null,

            // 평가 참여자 관리 모달 (기업 상세 화면과 같은 컴포넌트)
            member_modal_company: null,
            is_loading_member_modal: false,
            
            service_type_variant: {
                '일반': 'bgray-400',
                '심화': 'bg-red4'
            }

        }
    },
    computed: {
        is_admin() {
            return Number(this.$store.getters.isAdmin)
        },
        is_gloabl_loading () {
            return this.is_initial_loading || this.is_loading_assessments || this.is_loading_change_answer_mode || this.is_loading_submit_by_qesg
        },
        projectCodeOptions() {
            return getProjectCodeOptions(this.projects)
        },
        // 필터의 '답변중'은 보완요청(in_progress + in_assessment_ts) 건도 함께 걸린다
        statusOptions() {
            return STATUS_FILTER_CODES.map(value => ({
                value,
                text: value === 'in_progress' ? `${STATUS_LABELS.in_progress}(보완요청 포함)` : STATUS_LABELS[value]
            }))
        },
        emptyText() {
            return this.periods_error && !this.applied_filters.periods.length
                ? '기간 목록을 먼저 불러와야 조회할 수 있습니다.'
                : '조회된 평가가 없습니다.'
        }
    },
    watch: {
        // 사이드바 재클릭(빈 query)·뒤로가기처럼 같은 라우트에서 query 만 바뀌면 화면을 맞춘다.
        // 이 화면이 직접 바꾼 URL 은 buildQuery() 와 같아서 무시된다.
        '$route.query'(query) {
            if (!this.query_ready) return
            const current = this.buildQuery()
            const filterKeys = ['periods', ...FILTER_KEYS]
            const sameFilters = queryKey(query, filterKeys) === queryKey(current, filterKeys)
            if (sameFilters && queryKey(query, VIEW_KEYS) === queryKey(current, VIEW_KEYS)) return
            this.applyFiltersFromQuery()
            // 페이지·정렬만 바뀌었으면 다시 조회하지 않는다(클라이언트 페이징·정렬)
            if (sameFilters) this.$nextTick(this.fitPage)
            else this.fetchAssessments()
        }
    },
    async created() {
        this.is_initial_loading = true
        // 기본 기간과 링크의 프로젝트 코드 판정에 두 목록이 다 필요하다
        await Promise.all([this.getAllPeriods(), this.getProjectCodes()])
        // 첫 조회 중에 URL 이 바뀌면 watcher 가 새로 조회하고 이 응답은 순번으로 버려진다
        this.query_ready = true
        this.applyFiltersFromQuery()
        await this.fetchAssessments()
        this.is_initial_loading = false
    },
    methods: {
        // 오류 표시는 성공해야 지운다 — 다시 시도하는 동안에도 전 기간 조회 차단을 유지한다
        async getAllPeriods() {
            try {
                const response = await this.$axios.get('/assessments/periods')
                this.periods = response.data.map(_period => ({ text: _period, value: _period }))
                this.periods_error = false
            } catch (error) {
                console.error('Error searching periods:', error);
                this.periods_error = true
            }
        },
        async getProjectCodes() {
            try {
                const response = await this.$axios.get('/project_code')
                this.projects = response.data
                this.projects_error = false
            } catch (error) {
                console.error('Error loading project codes:', error);
                this.projects_error = true
            }
        },
        async retryPeriods() {
            await this.getAllPeriods()
            if (this.periods_error) return
            // URL 에 기간이 없던 경우 이제 기본 기간(최신)으로 조회할 수 있다
            this.applyFiltersFromQuery()
            this.fetchAssessments()
        },
        async retryProjectCodes() {
            await this.getProjectCodes()
            if (this.projects_error || !this.syncSelectedProjectId()) return
            this.applied_filters = this.cloneFilters(this.filters)
            this.syncQuery('replace')
            this.fetchAssessments()
        },
        defaultPeriods() {
            return this.periods.length ? [this.periods[0].value] : []
        },
        // 기간 키가 없으면 기본(최신 1개), 'all' 이면 전체 기간. 배열로 온 단일 조건은 무효
        filtersFromQuery(q) {
            const filters = { periods: q.periods == null ? this.defaultPeriods() : q.periods === 'all' ? [] : [].concat(q.periods) }
            FILTER_KEYS.forEach(k => { filters[k] = typeof q[k] === 'string' && q[k] ? q[k] : null })
            return filters
        },
        cloneFilters(filters) {
            return { ...filters, periods: [...filters.periods] }
        },
        // URL → 화면 상태
        applyFiltersFromQuery() {
            const q = this.$route.query || {}
            this.filters = this.filtersFromQuery(q)
            const page = Number(q.current_page)
            this.requested_page = this.assessment_currentPage = Number.isInteger(page) && page > 0 ? page : 1
            const sortable = this.assessment_fields.some(f => f.sortable && f.key === q.sort_by)
            this.sortBy = sortable ? q.sort_by : ''
            this.sortDesc = sortable && q.sort_desc === '1'
            const dropped = this.syncSelectedProjectId()
            this.applied_filters = this.cloneFilters(this.filters)
            if (dropped) this.syncQuery('replace')
        },
        // 화면 상태 → URL query. 기본값·빈 값은 생략한다
        buildQuery() {
            const query = {}
            const periods = this.applied_filters.periods
            const defaults = this.defaultPeriods()
            const isDefault = periods.length === defaults.length && periods.every(p => defaults.includes(p))
            if (!isDefault) query.periods = periods.length ? [...periods] : 'all'
            FILTER_KEYS.forEach(k => { if (this.applied_filters[k]) query[k] = String(this.applied_filters[k]) })
            if (this.assessment_currentPage > 1) query.current_page = String(this.assessment_currentPage)
            if (this.sortBy) {
                query.sort_by = this.sortBy
                if (this.sortDesc) query.sort_desc = '1'
            }
            return query
        },
        // 사용자 조작은 push, 자동 보정은 replace
        syncQuery(method) {
            const query = this.buildQuery()
            const keys = ['periods', ...FILTER_KEYS, ...VIEW_KEYS]
            if (queryKey(query, keys) === queryKey(this.$route.query, keys)) return
            this.$router[method]({ query }).catch(() => {})
        },
        // filters.project_code 에 맞춰 선택기를 맞춘다. 목록에 없는 코드(지워졌거나 오타)는 조건에서 빼고 true.
        // 프로젝트 목록을 못 불러왔으면 판정할 수 없으니 그대로 둔다.
        syncSelectedProjectId() {
            const code = this.filters.project_code
            const found = code && this.projects.flatMap(group => group.projects || []).find(p => p.project_code === code)
            this.selectedProjectId = found ? found.id : null
            if (!code || found || this.projects_error) return false
            this.filters.project_code = null
            this.$EventBus.$emit('toast-failure', '평가 관리', `링크의 프로젝트 코드(${code})를 찾을 수 없어 조건에서 뺐습니다.`)
            return true
        },
        onProjectCodeSelected(projectId) {
            if (!projectId) {
                this.filters.project_code = null
            } else {
                let code = null
                for (const group of this.projects) {
                    const found = (group.projects || []).find(p => p.id === projectId)
                    if (found) { code = found.project_code; break }
                }
                this.filters.project_code = code
            }
            this.searchAssessments()
        },
        selectAllPeriods() {
            this.filters.periods = this.periods.map(_p => _p.value)
            this.searchAssessments()
        },
        // 사용자가 조건을 바꿔 조회한다. isInitial === true 는 '초기화' 버튼(이벤트 객체가 넘어와도 무시)
        searchAssessments(isInitial = false) {
            if (isInitial === true) {
                this.filters = this.filtersFromQuery({})
                this.selectedProjectId = null
                this.sortBy = ''
                this.sortDesc = false
            }
            this.requested_page = this.assessment_currentPage = 1
            this.applied_filters = this.cloneFilters(this.filters)
            this.syncQuery('push')
            return this.fetchAssessments()
        },
        onPageChange(page) {
            this.requested_page = this.assessment_currentPage = page
            this.syncQuery('push')
        },
        // 원한 페이지가 결과 범위를 넘으면(링크·뒤로가기) 마지막 페이지로 맞추고 URL 을 replace
        fitPage() {
            const lastPage = Math.max(1, Math.ceil(this.assessments.length / this.assessment_perPage))
            this.requested_page = this.assessment_currentPage = Math.min(this.requested_page, lastPage)
            this.syncQuery('replace')
        },
        onSortChanged({ sortBy, sortDesc }) {
            this.sortBy = sortBy
            this.sortDesc = sortDesc
            this.syncQuery('push')
        },
        async fetchAssessments() {
            const token = ++this.search_token
            const { periods } = this.applied_filters
            this.list_error = ''
            if (this.periods_error && !periods.length) {
                // 기간 목록 없이 조회하면 전 기간을 한꺼번에 불러오게 된다
                this.assessments = []
                this.data_num = 0
                this.is_loading_assessments = false
                return
            }
            const filters = periods.length ? { periods } : {}
            FILTER_KEYS.forEach(k => { if (this.applied_filters[k]) filters[k] = this.applied_filters[k] })
            try {
                this.is_loading_assessments = true
                const response = await this.$axios.get('/assessments', { params: { filters } })
                if (token !== this.search_token) return
                this.data_num = response.data.total_assessments
                this.assessments = response.data.list
                // 새 건수로 다시 그려진 뒤 페이지를 맞춘다 — 먼저 맞추면 b-pagination 이 이전 건수 기준으로 깎는다
                await this.$nextTick()
                if (token !== this.search_token) return
                this.fitPage()
            } catch (error) {
                if (token !== this.search_token) return
                console.error('Error searching assessments:', error);
                this.assessments = []
                this.data_num = 0
                if (error?.response?.status === 401) return
                this.list_error = '평가 목록을 불러오지 못했습니다.'
                this.$EventBus.$emit('toast-failure', '조회 실패', getErrorMessage(error, '평가 목록을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.'))
            } finally {
                if (token === this.search_token) this.is_loading_assessments = false
            }
        },
        getStatusVarient({ status_code, in_assessment_ts }) {
            const status_code_variant_set = {
                'requested': 'success',
                'in_progress': 'secondary',
                'in_assessment': 'danger',
                're_progress': 'warning',
                'completed': 'dark',
                'canceled': 'light',
                'not_requested': 'light'
            }

            if (status_code_variant_set[status_code]) {
                if (status_code == 'in_progress' && in_assessment_ts) {
                    status_code_variant_set[status_code] = 'primary'
                }
                return status_code_variant_set[status_code]
            } else {
                return 'advance'
            }
        },
        // 필터 라벨과 같은 단어. 평가가 시작된 뒤 답변중으로 되돌아간 건은 보완요청
        getKoreanStatus({ status_code, in_assessment_ts }) {
            if (status_code === 'in_progress' && in_assessment_ts) return STATUS_LABELS.supplement
            return STATUS_LABELS[status_code] || status_code
        },
        async submitAnswerByQesg(company) {
            if (this.is_loading_submit_by_qesg) return false
            const h = this.$createElement
            let _noti_force_submit = true
            const _confirm_force_submit = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '임의 제출',
                message: h('div', [
                    h('div', {style: {whiteSpace: 'pre-line'}},
                        `${company.company_name} · 프로젝트 ${company.project_code} · 캠페인 ${company.campaign_id} · 제출기한 ${company.duedate_ts}
제출하면 기업은 더 이상 답변을 고칠 수 없고 평가 단계로 넘어갑니다(되돌리려면 답변수정 필요).`),
                    h('label', {class: 'mt-2 mb-0 d-block'}, [
                        h('input', {
                            attrs: {type: 'checkbox', checked: true},
                            class: 'mr-1',
                            on: {change: (e) => { _noti_force_submit = e.target.checked }}
                        }),
                        '기업에게 제출 안내 메일 발송'
                    ])
                ])
            })
            if (!_confirm_force_submit) {
                return false
            }
            try {
                this.is_loading_submit_by_qesg = true;
                const { campaign_id, company_id, project_code } = company
                await this.$axios.put('/company/submit', {
                    campaign_id, company_id, project_code,
                    is_force_sumit: true,
                    is_force_submit_noti: _noti_force_submit
                })
                this.getDuedateVarient(company)
                if (this.$refs.assessmentTable) {
                    this.$nextTick(() => {
                        this.$refs.assessmentTable.refresh()
                    })
                }
                this.$EventBus.$emit('toast-success', '임의 제출', `${company.company_name}의 답변을 임의 제출 하였습니다. (안내 메일 ${_noti_force_submit ? '발송' : '미발송'})`)
                company.status_code = "in_assessment"
            } catch (error) {
                console.log(error)
                if (error?.response?.status === 401) return
                this.$EventBus.$emit('toast-failure', '임의 제출 실패', getErrorMessage(error, `${company.company_name}의 답변을 임의 제출하는 중 장애가 발생했습니다. 제출 상태를 확인한 뒤 다시 시도해주세요.`))
            } finally {
                this.is_loading_submit_by_qesg = false;
            }
        },
        async backToInProgress(company) {
            const _is_confirm_change_answer_mode = await this.$showModal({
                type: 'confirm',
                state: 'warning',
                title: '답변수정',
                message: `${company.company_name} · ${company.project_code} 를 답변 가능한 상태로 되돌립니다. 기업이 다시 제출할 때까지 평가가 멈춥니다.`
            })
            if (!_is_confirm_change_answer_mode) {
                return false
            }
            try {
                this.is_loading_change_answer_mode = true

                this.getDuedateVarient(company)
                if (this.$refs.assessmentTable) {
                    this.$nextTick(() => {
                        this.$refs.assessmentTable.refresh()
                    })
                }

                const response = await this.$axios.put('/company/submit/cancel',
                    {
                        project_code: company.project_code,
                        company_id: company.company_id,
                        campaign_id: company.campaign_id
                    }
                )
                this.$EventBus.$emit('toast-success', '상태 변경 완료', `${company.company_name} (${response.data.company_id}) 를 답변 가능한 상태로 변환하였습니다.`)
                company.status_code = "in_progress"
            } catch (error) {
                const { status, data } = error.response || {}
                if (status === 401) return
                if (status === 404 && data?.message === "Not_Found_Assessment_Request") {
                    this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company.company_name}의 평가신청 이력을 찾을 수 없습니다. 개발팀에 문의해주세요.`)
                } else if (status === 400 && data?.message === "Not_Status_Change") {
                    this.$EventBus.$emit('toast-failure', '상태 변경 실패', `${company.company_name} 가 답변 가능한 상태로 변경할 수 없는 상태입니다. 개발팀에 문의해주세요.`)
                } else {
                    this.$EventBus.$emit('toast-failure', '상태 변경 실패', getErrorMessage(error, `${company.company_name} 를 답변 가능한 상태로 변환 중 장애가 발생했습니다. 개발팀에 문의해주세요.`))
                }
            } finally {
                this.is_loading_change_answer_mode = false
            }
        },
        getDuedateVarient(item) {
            let today = new Date()
            let duedate = new Date(item.duedate_ts)
            if (item.status_code === 'requested' || item.status_code === 'in_progress') {
                if (today.getTime() >= duedate.getTime()) {
                    item._cellVariants = { duedate_ts: 'danger' }
                } else {
                    let day_gap = duedate.getTime() - today.getTime()
                    let left_days = Math.floor(day_gap / (1000 * 60 * 60 * 24));
                    if (left_days <= 3) {
                        item._cellVariants = { duedate_ts: 'primary' }
                    }
                }
            }
        },
        async openMemberModal(item) {
            if (this.is_loading_member_modal) return
            try {
                this.is_loading_member_modal = true
                const { data } = await this.$axios.get(`/admin/company/${item.company_id}/info`)
                const { company, member, projects } = data
                const project = (projects || []).find(p => p.project_code === item.project_code
                    && (!item.campaign_id || Number(p.campaign_id) === Number(item.campaign_id)))
                if (!project) {
                    this.$EventBus.$emit('toast-failure', '평가 참여자 관리', `${item.company_name} 의 ${item.project_code} 평가 신청 건을 찾을 수 없습니다.`)
                    return
                }
                // 기업 상세 화면(CompanyManagementDetail.fetchDetailData)과 같은 모양으로 넘긴다.
                this.member_modal_company = {
                    company_id: item.company_id,
                    company_name: company.company_name,
                    member: member.map((m, index) => ({ ...m, index })),
                    projects
                }
                await this.$nextTick()
                await this.$refs['assessment-member-modal'].manageProjectMember(project)
            } catch (error) {
                console.error(error)
                this.$EventBus.$emit('toast-failure', '평가 참여자 관리', '기업 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.')
            } finally {
                this.is_loading_member_modal = false
            }
        },
        openCommentModal(company) {
            this.comment_info = company

            this.$nextTick(() => {
                this.$bvModal.show('comment-modal')
            })
        }
    }
}
</script>
  
<style lang="scss">
.small-text {
    font-size: 80% !important;
}

.date-text {
    font-size: 90% !important;
}
</style>